/*
 * File: /src/router/routes/segments.js
 * Created Date: Saturday June 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 15th June 2019 10:54:47 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

const SegmentList = () =>
  import(/* webpackChunkName: "SegmentList" */ 'src/components/Dashboard/Views/Contacts/Segments/SegmentList.vue');

export const segmentsRoutes = [
  {
    path: 'contacts/segments',
    name: 'Segments',
    component: SegmentList
  }
];
